import React from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';
import PropTypes from 'prop-types';

import { formatDateShortMonth } from '../../utils/helpers';
import * as TrackedItem from '../../utils/trackedItemContent';
import { standard5103Item } from '../../constants';

export default function FilesNeeded({ claimId, item, previousPage = null }) {
  // useNavigate for client-side routing (avoids full page reload with VaLinkAction).
  // This is how 'to=""' worked in the previous version of this component.
  const navigate = useNavigate();
  // We will not use the truncateDescription() here as these descriptions are custom and specific to what we want
  // the user to see based on the given item type.
  const itemsWithNewDescriptions = [
    {
      type: 'Automated 5103 Notice Response',
      description: standard5103Item.description,
    },
  ];

  const getItemDisplayName = () => {
    if (TrackedItem.isAutomated5103Notice(item.displayName)) {
      return standard5103Item.displayName;
    }
    if (TrackedItem.getIsSensitive(item)) {
      return TrackedItem.REQUEST_FOR_EVIDENCE_LABEL;
    }
    if (TrackedItem.getNoProvidePrefix(item)) {
      return item.friendlyName;
    }
    if (item.friendlyName) {
      return `Provide ${TrackedItem.getDisplayFriendlyName(item)}`;
    }
    return TrackedItem.REQUEST_FOR_EVIDENCE_LABEL;
  };

  const getItemDescription = () => {
    const itemWithNewDescription = itemsWithNewDescriptions.find(
      i => i.type === item.displayName,
    );
    if (item.shortDescription || item.activityDescription) {
      return item.shortDescription || item.activityDescription;
    }
    return itemWithNewDescription !== undefined
      ? itemWithNewDescription.description
      : TrackedItem.truncateDescription(item.description); // Truncating the item description to only 200 characters incase it is long
  };
  const description = getItemDescription();
  const detailHref = `/track-claims/your-claims/${claimId}/needed-from-you/${item.id}`;

  const handleNavigation = e => {
    e.preventDefault();

    if (previousPage !== null) {
      sessionStorage.setItem('previousPage', previousPage);
    }

    navigate(`/your-claims/${claimId}/needed-from-you/${item.id}`);
  };

  return (
    <va-card data-testid={`item-${item.id}`} class="vads-u-margin-bottom--2">
      <h4 className="vads-u-margin-top--0">{getItemDisplayName()}</h4>
      {description &&
        (typeof description === 'string' ? <p>{description}</p> : description)}
      <va-critical-action
        link={detailHref}
        text={`Requested by ${formatDateShortMonth(item.suspenseDate)}`}
        onClick={handleNavigation}
      />
    </va-card>
  );
}

FilesNeeded.propTypes = {
  claimId: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  previousPage: PropTypes.string,
};
